<div *ngIf="loading">
  <div class="row justify-content-center">
    <span class="k-icon k-i-loading kendo-loading-icon"></span>
  </div>
</div>
<div class="scroll" *ngIf="memberForm !== undefined && !loading">
  <form [formGroup]="memberForm">
    <kendo-tabstrip #tabstrip (tabSelect)="onSelectTab($event)">
      <kendo-tabstrip-tab title="{{'MEMBER' | translate:patientLabel}}" [selected]="!openPatientConsentTab">
        <ng-template kendoTabContent>
          <div class="tab-patient k-form">
            <div class="row">
              <div class="col">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('FIRST_NAME'), 'k-text-uppercase-bold': isRecommended('FIRST_NAME')}">
                    {{'FIRST-NAME' | translate}} {{requiredLabel('FIRST_NAME')}}
                  </span>
                  <input id="firstName" kendoTextBox formControlName="firstName" maxlength="150" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="firstName.hasError('required') && (firstName.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('FIRST_NAME')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
              <div class="col">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('LAST_NAME'), 'k-text-uppercase-bold': isRecommended('LAST_NAME')}">
                    {{'LAST-NAME' | translate}} {{requiredLabel('LAST_NAME')}}
                  </span>
                  <input id="lastName" kendoTextBox formControlName="lastName" maxlength="150" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="lastName.hasError('required') && (lastName.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('LAST_NAME')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
              <div class="col">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('MIDDLE_NAME'), 'k-text-uppercase-bold': isRecommended('MIDDLE_NAME')}">
                    {{'MIDDLE-NAME' | translate}}
                  </span>
                  <input id="middleName" kendoTextBox formControlName="middleName" maxlength="150" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('PREFERRED_NAME'), 'k-text-uppercase-bold': isRecommended('PREFERRED_NAME')}">
                    {{'PREFERRED-NAME' | translate}} {{requiredLabel('PREFERRED_NAME')}}
                  </span>
                  <input id="preferredName" kendoTextBox formControlName="preferredName" class="w-100" maxlength="50" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="preferredName.hasError('required') && (preferredName.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('PREFERRED_NAME')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="namePronouns.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('NAME_PRONOUN'), 'k-text-uppercase-bold': isRecommended('NAME_PRONOUN')}">
                    {{'NAME-PRONOUN' | translate}} {{requiredLabel('NAME_PRONOUN')}}
                  </span>
                  <kendo-combobox id="namePronoun" formControlName="namePronoun" [data]="namePronouns"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="namePronoun.hasError('required') && (namePronoun.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('NAME_PRONOUN')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="namePronouns.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('NAME_PRONOUN_OTHER'), 'k-text-uppercase-bold': isRecommended('NAME_PRONOUN_OTHER')}">
                    {{'NAME-PRONOUN-OTHER' | translate}} {{requiredLabel('NAME_PRONOUN_OTHER')}}
                  </span>
                  <input id="namePronounOther" kendoTextBox formControlName="namePronounOther" class="w-100"
                    maxlength="50" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="namePronounOther.hasError('required') && (namePronounOther.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('NAME_PRONOUN_OTHER')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('DATE_OF_BIRTH'), 'k-text-uppercase-bold': isRecommended('DATE_OF_BIRTH')}">
                    {{'DATE-OF-BIRTH' | translate}} {{requiredLabel('DATE_OF_BIRTH')}}
                  </span>
                  <kendo-datepicker [min]="minDOB" [max]="maxDOB" formControlName="dateOfBirth">
                  </kendo-datepicker>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="dateOfBirth.hasError('required') && (dateOfBirth.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('DATE_OF_BIRTH')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="dateOfBirth.invalid && !dateOfBirth.hasError('required') && (dateOfBirth.touched || (memberForm.dirty && !isNew))">
                    <span>{{ 'DATE-INVALID' | translate }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="genders.length > 0 && showGender">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('GENDER'), 'k-text-uppercase-bold': isRecommended('GENDER')}">
                    {{'GENDER' | translate}} {{requiredLabel('GENDER')}}
                  </span>
                  <kendo-combobox id="gender" formControlName="gender" [data]="genders" [textField]="'displayName'"
                    [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="gender.hasError('required') && (gender.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('GENDER')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="genders.length > 0 && showAdministrativeGender">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('ADMINISTRATIVE_GENDER'), 'k-text-uppercase-bold': isRecommended('ADMINISTRATIVE_GENDER')}">
                    {{'ADMINISTRATIVE-GENDER' | translate}} {{requiredLabel('ADMINISTRATIVE_GENDER')}}
                  </span>
                  <kendo-combobox id="administrativeGender" formControlName="administrativeGender" [data]="genders"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="administrativeGender.hasError('required') && (administrativeGender.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('ADMINISTRATIVE_GENDER')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4" *ngIf="allSpokenLanguages.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('SPOKEN_LANGUAGES'), 'k-text-uppercase-bold': isRecommended('SPOKEN_LANGUAGES')}">
                    {{'SPOKEN-LANGUAGES' | translate}} {{requiredLabel('SPOKEN_LANGUAGES')}}
                  </span>
                  <kendo-multiselect id="spokenLanguages" [data]="spokenLanguagesFiltered" role="combobox"
                    formControlName="spokenLanguages" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterSpokenLanguages($event)" (close)="searchTerm=''"
                    [autoClose]="true" [virtual]="virtualSpokenLanguage"
                    attr.aria-label="{{'SPOKEN-LANGUAGES' | translate}}" aria-expanded="false"
                    aria-controls=".k-list-ul">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="spokenLanguages.hasError('required') && (spokenLanguages.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('SPOKEN_LANGUAGES')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="allWrittenLanguages.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('WRITTEN_LANGUAGES'), 'k-text-uppercase-bold': isRecommended('WRITTEN_LANGUAGES')}">
                    {{'WRITTEN-LANGUAGES' | translate}} {{requiredLabel('WRITTEN_LANGUAGES')}}
                  </span>
                  <kendo-multiselect id="writtenLanguages" [data]="writtenLanguagesFiltered"
                    formControlName="writtenLanguages" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterWrittenLanguages($event)" (close)="searchTerm=''"
                    [autoClose]="true" [virtual]="virtualWrittenLanguage">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="writtenLanguages.hasError('required') && (writtenLanguages.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('WRITTEN_LANGUAGES')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="allReadingLanguages.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('READING_LANGUAGES'), 'k-text-uppercase-bold': isRecommended('READING_LANGUAGES')}">
                    {{'READING-LANGUAGES' | translate}} {{requiredLabel('READING_LANGUAGES')}}
                  </span>
                  <kendo-multiselect id="readingLanguages" [data]="readingLanguagesFiltered"
                    formControlName="readingLanguages" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterReadingLanguages($event)" (close)="searchTerm=''"
                    [autoClose]="true" [virtual]="virtualReadingLanguage">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="readingLanguages.hasError('required') && (readingLanguages.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('READING_LANGUAGES')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4" *ngIf="videoProviders.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('VIDEO_PROVIDER'), 'k-text-uppercase-bold': isRecommended('VIDEO_PROVIDER')}">
                    {{'PREFERRED-VIDEO-PROVIDER' | translate}} {{requiredLabel('VIDEO_PROVIDER')}}
                  </span>
                  <kendo-combobox id="preferredVideoProvider" formControlName="preferredVideoProvider"
                    [data]="videoProviders" [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="preferredVideoProvider.hasError('required') && (preferredVideoProvider.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('VIDEO_PROVIDER')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="allEnhancedServices.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('ENHANCED_SERVICE_ELIGIBILITY'), 'k-text-uppercase-bold': isRecommended('ENHANCED_SERVICE_ELIGIBILITY')}">
                    {{'ENHANCED-SERVICE-ELIGIBILITY' | translate}} {{requiredLabel('ENHANCED_SERVICE_ELIGIBILITY')}}
                  </span>
                  <kendo-multiselect id="enhancedServices" [data]="enhancedServicesFiltered" role="combobox"
                    formControlName="enhancedServices" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterEnhancedServices($event)" (close)="searchTerm=''"
                    [autoClose]="true" [virtual]="virtualEnhancedService"
                    attr.aria-label="{{'ENHANCED-SERVICE-ELIGIBILITY' | translate}}">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="enhancedServices.hasError('required') && (enhancedServices.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('ENHANCED_SERVICE_ELIGIBILITY')}">{{
                      'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4" *ngIf="englishProficiencies.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('ENGLISH_PROFICIENCY'), 'k-text-uppercase-bold': isRecommended('ENGLISH_PROFICIENCY')}">
                    {{'ENGLISH-PROFICIENCY' | translate}} {{requiredLabel('ENGLISH_PROFICIENCY')}}
                  </span>
                  <kendo-combobox id="englishProficiency" formControlName="englishProficiency"
                    [data]="englishProficiencies" [textField]="'displayName'" [valueField]="'code'"
                    [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="englishProficiency.hasError('required') && (englishProficiency.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('ENGLISH_PROFICIENCY')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="interpreterNeeds.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('INTERPRETER_NEED'), 'k-text-uppercase-bold': isRecommended('INTERPRETER_NEED')}">
                    {{'INTERPRETER-NEED' | translate}} {{requiredLabel('INTERPRETER_NEED')}}
                  </span>
                  <kendo-combobox id="interpreterNeed" formControlName="interpreterNeed" [data]="interpreterNeeds"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="interpreterNeed.hasError('required') && (interpreterNeed.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('INTERPRETER_NEED')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="interpreterNeeds.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('INTERPRETER_NEED_OTHER'), 'k-text-uppercase-bold': isRecommended('INTERPRETER_NEED_OTHER')}">
                    {{'INTERPRETER-NEED-OTHER' | translate}} {{requiredLabel('INTERPRETER_NEED_OTHER')}}
                  </span>
                  <input id="interpreterNeedOther" kendoTextBox formControlName="interpreterNeedOther" class="w-100"
                    maxlength="50" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="interpreterNeedOther.hasError('required') && (interpreterNeedOther.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('INTERPRETER_NEED_OTHER')}">{{
                      'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div>* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{'CONTACT' | translate}}" [selected]="false">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('HOME_PHONE'), 'k-text-uppercase-bold': isRecommended('HOME_PHONE')}">
                    <i class="fas fa-phone fa-fw"></i>
                    {{ 'HOME-PHONE' | translate}} {{requiredLabel('HOME_PHONE')}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="homePhone" formControlName="homePhone">
                  </kendo-maskedtextbox>
                  <input *ngIf="homePhone.value" type="checkbox" class="custom-safe" kendoCheckBox
                    title="{{'SAFE' | translate}}" formControlName="homePhoneSafe"
                    [indeterminate]="homePhoneSafe.value === null" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="homePhone.invalid && (homePhone.touched || (memberForm.dirty && !isNew))">
                    <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('CELL_PHONE'), 'k-text-uppercase-bold': isRecommended('CELL_PHONE')}">
                    <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
                    {{requiredLabel('CELL_PHONE')}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="cellPhone" formControlName="cellPhone">
                  </kendo-maskedtextbox>
                  <input *ngIf="cellPhone.value" type="checkbox" class="custom-safe" kendoCheckBox
                    title="{{'SAFE' | translate}}" formControlName="cellPhoneSafe"
                    [indeterminate]="cellPhoneSafe.value === null" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="cellPhone.invalid && (cellPhone.touched || (memberForm.dirty && !isNew))">
                    <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
                  </div>
                </label>
              </div>
              <div class="col-3">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('WORK_PHONE'), 'k-text-uppercase-bold': isRecommended('WORK_PHONE')}">
                    <i class="fas fa-phone-office fa-fw"></i> {{'WORK-PHONE' | translate}}
                    {{requiredLabel('WORK_PHONE')}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="workPhoneNumber" formControlName="workPhoneNumber">
                  </kendo-maskedtextbox>
                  <input *ngIf="workPhoneNumber.value" type="checkbox" class="custom-safe" kendoCheckBox
                    title="{{'SAFE' | translate}}" formControlName="workPhoneSafe"
                    [indeterminate]="workPhoneSafe.value === null" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="workPhoneNumber.invalid && (workPhoneNumber.touched || (memberForm.dirty && !isNew))">
                    <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
                  </div>
                </label>
              </div>
              <div class="col-1 pl-0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('WORK_EXTENSION'), 'k-text-uppercase-bold': isRecommended('WORK_EXTENSION')}">
                    {{'PHONE-EXTENSION-PREFIX' | translate}}
                  </span>
                  <input id="workPhoneNumberExtension" kendoTextBox formControlName="workPhoneNumberExtension"
                    class="w-100" maxlength="20" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('OTHER_PHONE'), 'k-text-uppercase-bold': isRecommended('OTHER_PHONE')}">
                    <i class="fas fa-phone fa-fw"></i> {{'OTHER-PHONE' | translate}} {{requiredLabel('OTHER_PHONE')}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="otherPhoneNumber"
                    formControlName="otherPhoneNumber">
                  </kendo-maskedtextbox>
                  <input *ngIf="otherPhoneNumber.value" type="checkbox" class="custom-safe" kendoCheckBox
                    title="{{'SAFE' | translate}}" formControlName="otherPhoneSafe"
                    [indeterminate]="otherPhoneSafe.value === null" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="otherPhoneNumber.invalid && (otherPhoneNumber.touched || (memberForm.dirty && !isNew))">
                    <span>{{ 'IMPORT-PHONE-INVALID' | translate }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="patientDemographicsEnablePager">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('PAGER'), 'k-text-uppercase-bold': isRecommended('PAGER')}">
                    <i class="fas fa-pager fa-fw"></i> {{'PAGER' | translate}} {{requiredLabel('PAGER')}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="pagerNumber" formControlName="pagerNumber">
                  </kendo-maskedtextbox>
                  <input *ngIf="pagerNumber.value" type="checkbox" class="custom-safe" kendoCheckBox
                    title="{{'SAFE' | translate}}" formControlName="pagerSafe"
                    [indeterminate]="pagerSafe.value === null" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="pagerNumber.hasError('required') && (pagerNumber.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('PAGER')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="patientDemographicsEnableFax">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('FAX'), 'k-text-uppercase-bold': isRecommended('FAX')}">
                    <i class="fas fa-fax fa-fw"></i> {{'FAX-OR-OTHER' | translate}} {{requiredLabel('FAX')}}
                  </span>
                  <kendo-maskedtextbox [mask]="phoneNumberMask" id="faxNumber" formControlName="faxNumber">
                  </kendo-maskedtextbox>
                  <input *ngIf="faxNumber.value" type="checkbox" class="custom-safe" kendoCheckBox
                    title="{{'SAFE' | translate}}" formControlName="faxSafe" [indeterminate]="faxSafe.value === null" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="faxNumber.hasError('required') && (faxNumber.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('FAX')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('EMAIL'), 'k-text-uppercase-bold': isRecommended('EMAIL')}">
                    <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}} {{requiredLabel('EMAIL')}}
                  </span>
                  <input id="email" kendoTextBox formControlName="email" email maxlength="255" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="email.hasError('required') && (email.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('EMAIL')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="email.invalid && email.touched && email.value">
                    {{'WRONG-EMAIL-FORMAT' | translate}}
                  </div>
                </label>
              </div>
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('PREFERRED_CONTACT_METHODS'), 'k-text-uppercase-bold': isRecommended('PREFERRED_CONTACT_METHODS')}">
                    {{'PREFERRED-CONTACT-METHODS' | translate}} {{requiredLabel('PREFERRED_CONTACT_METHODS')}}
                  </span>
                  <kendo-multiselect id="preferredContactMethods" [data]="contactMethods" role="combobox"
                    formControlName="preferredContactMethods" [textField]="'text'" [filterable]="false"
                    [valueField]="'value'" [valuePrimitive]="true"
                    attr.aria-label="{{'PREFERRED-CONTACT-METHODS' | translate}}" aria-expanded="false"
                    aria-controls=".k-list-ul">
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="preferredContactMethods.hasError('required') && (preferredContactMethods.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('PREFERRED_CONTACT_METHODS')}">{{
                      'IS-REQUIRED' }}
                    </span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="patientDemographicsEnableWebsite">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('URL'), 'k-text-uppercase-bold': isRecommended('URL')}">
                    <i (click)="openUrl()" [ngClass]="{'has-valid-url': isValidUrl()}" class="fas fa-link fa-fw"></i>
                    {{'URL' | translate}} {{requiredLabel('URL')}}
                  </span>
                  <input id="url" kendoTextBox formControlName="url" maxlength="255" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="url.hasError('required') && (url.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('URL')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="!isValidUrl() && url.hasError('pattern') && url.touched">
                    {{'INVALID-WWW' | translate}}
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('NOTIFICATION_LANGUAGE'), 'k-text-uppercase-bold': isRecommended('NOTIFICATION_LANGUAGE')}">
                    {{'NOTIFICATION-LANGUAGE' | translate}} {{requiredLabel('NOTIFICATION_LANGUAGE')}}
                  </span>
                  <kendo-combobox id="preferredLanguage" formControlName="preferredLanguage" [data]="languages"
                    [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="preferredLanguage.hasError('required') && (preferredLanguage.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('NOTIFICATION_LANGUAGE')}">{{
                      'IS-REQUIRED' }}
                    </span>
                  </div>
                </label>
              </div>
              <div class="col-4">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('NOTIFICATION'), 'k-text-uppercase-bold': isRecommended('NOTIFICATION')}">
                    {{'NOTIFICATION' | translate}} {{requiredLabel('NOTIFICATION')}}
                  </span>
                  <kendo-dropdownlist attr.aria-label="{{'NOTIFICATION' | translate}}" id="notificationType"
                    formControlName="notificationType" [data]="notifications" [textField]="'text'"
                    [valueField]="'value'" [valuePrimitive]="true">
                  </kendo-dropdownlist>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="notificationType.hasError('required') && (notificationType.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('NOTIFICATION')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row" *ngIf="channelId !== undefined">
              <div class="col-4">
                <label class="k-form-field mt-3">
                  <span class="k-text-uppercase dark">
                    {{'ASSIGN-CASE-MANAGER' | translate}} <span *ngIf="selectedChannel !== undefined 
                              && selectedChannel.caseManagerAssignmentMode === null">*</span>
                  </span>
                  <kendo-combobox id="manager" formControlName="manager" [data]="caseManagers" [textField]="'name'"
                    [valueField]="'id'">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="manager.hasError('required') && (manager.touched || (memberForm.dirty && !isNew))">
                    {{'REQUIRED-MANAGER' | translate}}
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div>* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'ADDRESSES' | translate}}" [selected]="false">
        <ng-template kendoTabContent>
          <div class="p-1">
            <button *ngIf="!isReadOnly" kendoButton [primary]="true" (click)="addAddress()" type="button">
              {{'NEW-ADDRESS' | translate}}<i class="far fa-plus"></i>
            </button>
            <div *ngIf="memberForm.controls.addresses.controls.length === 0" class="row mb-4 mt-2"
              style="color: rgba(0, 0, 0, 0.25);">
              <div class="col-12">
                <span>{{'NO-ADDRESSES' | translate}}</span>
              </div>
            </div>
            <div formArrayName="addresses" class="container-opening-times">
              <div *ngFor="let address of memberForm.controls.addresses.controls; let i = index" [formGroupName]="i">
                <div class="k-form" [ngClass]="{'d-none': addressesCollapsed && i >= 1}">
                  <div class="row">
                    <div class="col-1 pr-0">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'PRIMARY' | translate}}
                        </span>
                        <input type="checkbox" formControlName="isPrimary" kendoCheckBox
                          (click)="primaryAddressClicked(i)"
                          [checked]="memberForm.controls.addresses.controls[i].controls.isPrimary.value" />
                      </label>
                    </div>
                    <div class="col-2">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'TYPE' | translate}} {{requiredLabel('ADDRESS_TYPE')}}
                        </span>
                        <kendo-combobox formControlName="addressType" [data]="addressTypes" [textField]="'displayName'"
                          [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('ADDRESS_LINE1'), 'k-text-uppercase-bold': isRecommended('ADDRESS_LINE1')}">
                          {{'STREET' | translate}} {{requiredLabel('ADDRESS_LINE1')}}
                        </span>
                        <input id="streetLine" kendoTextBox formControlName="streetLine" class="w-100"
                          maxlength="250" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.addresses.controls[i].controls.streetLine.hasError('required') && 
                                                    memberForm.controls.addresses.controls[i].controls.streetLine.touched">
                          <span translate [translateParams]="{field: requiredText('ADDRESS_LINE1')}">{{ 'IS-REQUIRED'
                            }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('ADDRESS_LINE2'), 'k-text-uppercase-bold': isRecommended('ADDRESS_LINE2')}">
                          {{'ADDRESS-LINE-2' | translate}}
                        </span>
                        <input id="streetLineAdditional" kendoTextBox formControlName="streetLineAdditional"
                          class="w-100" maxlength="250" />
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('CITY'), 'k-text-uppercase-bold': isRecommended('CITY')}">
                          {{'CITY' | translate}} {{requiredLabel('CITY')}}
                        </span>
                        <input id="city" kendoTextBox formControlName="city" class="w-100" maxlength="150" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.addresses.controls[i].controls.city.hasError('required') && memberForm.controls.addresses.controls[i].controls.city.touched">
                          <span translate [translateParams]="{field: requiredText('CITY')}">{{ 'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="row" style="margin-top:-15px;">
                    <div class="col-2 offset-1">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('COUNTY'), 'k-text-uppercase-bold': isRecommended('COUNTY')}">
                          {{'COUNTY' | translate}} {{requiredLabel('COUNTY')}}
                        </span>
                        <input id="county" kendoTextBox formControlName="county" class="w-100" maxlength="150" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.addresses.controls[i].controls.county.hasError('required') && memberForm.controls.addresses.controls[i].controls.county.touched">
                          <span translate [translateParams]="{field: requiredText('COUNTY')}">{{ 'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('STATE'), 'k-text-uppercase-bold': isRecommended('STATE')}">
                          {{'STATE' | translate}} {{requiredLabel('STATE')}}
                        </span>
                        <kendo-combobox formControlName="state" [data]="states" [textField]="'displayName'"
                          [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.addresses.controls[i].controls.state.hasError('required') && memberForm.controls.addresses.controls[i].controls.state.touched">
                          <span translate [translateParams]="{field: requiredText('STATE')}">{{ 'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('ZIP_POSTAL_CODE'), 'k-text-uppercase-bold': isRecommended('ZIP_POSTAL_CODE')}">
                          {{'POSTAL-CODE' | translate}} {{requiredLabel('ZIP_POSTAL_CODE')}}
                        </span>
                        <input id="postalCode" kendoTextBox formControlName="postalCode" class="w-100" maxlength="20" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.addresses.controls[i].controls.postalCode.hasError('required') && memberForm.controls.addresses.controls[i].controls.postalCode.touched">
                          <span translate [translateParams]="{field: requiredText('ZIP_POSTAL_CODE')}">{{ 'IS-REQUIRED'
                            }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-2 pr-0">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('COUNTRY'), 'k-text-uppercase-bold': isRecommended('COUNTRY')}">
                          {{'COUNTRY' | translate}} {{requiredLabel('COUNTRY')}}
                        </span>
                        <kendo-combobox id="country" class="w-100" formControlName="country" [data]="countries"
                          [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.addresses.controls[i].controls.country.hasError('required') && memberForm.controls.addresses.controls[i].controls.country.touched">
                          <span translate [translateParams]="{field: requiredText('COUNTRY')}">{{ 'IS-REQUIRED'
                            }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-1 text-right pl-0" style="margin-top:40px" *ngIf="!isReadOnly">
                      <i *ngIf="addressAPIEnabled && memberForm.controls.addresses.controls[i].controls.streetLine.value"
                        class="far fa-search-location pointer ml-3 fa-1_5x"
                        style="color:#3e807c;position: absolute;left: 8px;"
                        title="{{'VALIDATE-ADDRESS-ICON' | translate}}" (click)="validateAddress(i)"></i>
                      <a title="{{ 'DELETE' | translate }}"
                        (click)="removeAddress(i,memberForm.controls.addresses.controls[i].controls.id.value)">
                        <i class="fas fa-fw fa-times-circle fa-delete-custom" style="padding-top:4px;"></i>
                      </a>
                    </div>
                  </div>
                  <!--Other addresses-->
                  <div class="mt-2" *ngIf="i === 0 && memberForm.controls.addresses.controls.length > 1">
                    <span class="text-uppercase collapsible-text" (click)="addressesCollapsible.toggleChange()">
                      {{'OTHER-ADDRESSES' |
                      translate}}<span>&nbsp;({{memberForm.controls.addresses.controls.length-1}})</span>
                      <app-collapsible #addressesCollapsible [storageKey]="'patient-addresses'"
                        (collapsibleToggle)="addressesCollapsed=$event" [defaultCollapsed]="true">
                      </app-collapsible>
                    </span>
                  </div>
                  <hr *ngIf="memberForm.controls.addresses.controls.length > 1 &&
                                      i < memberForm.controls.addresses.controls.length-1"
                    [ngClass]="{'mt-0': i === 0 && memberForm.controls.addresses.controls.length > 1}">
                </div>
              </div>
            </div>
          </div>
          <div>* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab [selected]="false">
        <ng-template kendoTabTitle> <span>{{ 'HOUSEHOLD' | translate}}<i *ngIf="isHeadOfHousehold"
              class="fas fa-house-return fa-fw ml-1" title="{{'HEAD-OF-HOUSEHOLD' | translate}}"
              style="color:#FB8C00"></i></span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="k-form" style="height: 440px;">
            <div class="row">
              <div class="col-3" style="max-width: 316px;">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('HOUSEHOLD_SIZE'), 'k-text-uppercase-bold': isRecommended('HOUSEHOLD_SIZE')}">
                    {{'HOUSEHOLD-SIZE' | translate}} {{requiredLabel('HOUSEHOLD_SIZE')}}
                  </span>
                  <kendo-numerictextbox [format]="'n0'" formControlName="householdSize" [min]="0"
                    style="max-width:120px" #householdSizeControl>
                  </kendo-numerictextbox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="householdSize.hasError('required') && (householdSize.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('HOUSEHOLD_SIZE')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <!--Total Adults-->
              <div class="col-4">
                <div class="col-12" *ngIf="totalAdultsCodeSet.length > 0">
                  <div class="row">
                    <div class="col-8 text-center">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('TOTAL_ADULTS'), 'k-text-uppercase-bold': isRecommended('TOTAL_ADULTS')}">
                          {{'TOTAL-ADULTS' | translate}}
                        </span>
                      </label>
                    </div>
                    <div class="col-4" style="margin-left:-2px;max-width:112px;">
                      <input [disabled]="true" [(ngModel)]="totalAdults" kendoTextBox
                        [ngModelOptions]="{standalone: true}" style="background-color:#e5e9ef" />
                    </div>
                  </div>
                  <div class="age-container pr-1 pt-1" formArrayName="memberAdults">
                    <div class="row age-reduced-margin"
                      *ngFor="let adultAge of memberForm.controls.memberAdults.value;let i=index; trackBy:memberAdultsTrackBy;"
                      [formGroupName]="i">
                      <div class="col-8 text-right mt-3 pt-1">
                        <span class="k-text-uppercase dark"
                          *ngIf="adultAge.displayName !== undefined">{{adultAge.displayName.value}}</span>
                      </div>
                      <div class="col-4">
                        <label class="k-form-field">
                          <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="50">
                          </kendo-numerictextbox>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Total Children-->
              <div class="col-4">
                <div class="col-12" *ngIf="totalChildrenCodeSet.length > 0">
                  <div class="row">
                    <div class="col-8 text-center">
                      <label class="k-form-field">
                        <span
                          [ngClass]="{'k-text-uppercase dark': !isRecommended('TOTAL_CHILDREN'), 'k-text-uppercase-bold': isRecommended('TOTAL_CHILDREN')}">
                          {{'TOTAL-CHILDREN' | translate}}
                        </span>
                      </label>
                    </div>
                    <div class="col-4" style="margin-left:-2px;max-width:112px;">
                      <input [disabled]="true" [(ngModel)]="totalChildren" kendoTextBox
                        [ngModelOptions]="{standalone: true}" style="background-color:#e5e9ef" />
                    </div>
                  </div>
                  <div class="age-container pr-1 pt-1" formArrayName="memberChildren">
                    <div class="row age-reduced-margin"
                      *ngFor="let childAge of memberForm.controls.memberChildren.value;let i=index; trackBy:memberChildrenTrackBy;"
                      [formGroupName]="i">
                      <div class="col-8 text-right mt-3 pt-1">
                        <span class="k-text-uppercase dark"
                          *ngIf="childAge.displayName !== undefined">{{childAge.displayName.value}}</span>
                      </div>
                      <div class="col-4">
                        <label class="k-form-field">
                          <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="50">
                          </kendo-numerictextbox>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="position:absolute;top:85px;max-width:316px;">
              <div class="col-10" *ngIf="showDependents">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('DEPENDENTS'), 'k-text-uppercase-bold': isRecommended('DEPENDENTS')}">
                    {{'DEPENDENTS' | translate}} {{requiredLabel('DEPENDENTS')}}<span style="display: inline-flex">
                      <div kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(dependentsTooltip)" (mouseover)="showTooltip(dependentsTooltip)"
                        aria-live="polite" (blur)="hideTooltip()" (mouseout)="hideTooltip()">
                        <a #dependentsTooltip title="{{'DEPENDENTS-TOOLTIP' | translate }}"><i
                            class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </span>
                  <kendo-numerictextbox [format]="'n0'" formControlName="dependents" [min]="0" style="max-width:120px">
                  </kendo-numerictextbox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="dependents.hasError('required') && (dependents.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('DEPENDENTS')}">{{ 'IS-REQUIRED' }}</span>
                  </div>
                </label>
              </div>
              <div class="col-10">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('FAMILY_INCOME'), 'k-text-uppercase-bold': isRecommended('FAMILY_INCOME')}">
                    {{'FAMILY-INCOME' | translate}} {{requiredLabel('FAMILY_INCOME')}}
                  </span>
                </label>
              </div>
              <div class="col-12" style="margin-top:-18px">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FAMILY-INCOME-UNKNOWN-DECLINED' | translate}}
                  </span>
                  <input type="checkbox" [indeterminate]="familyIncomeUnknownDeclined.value === null"
                    formControlName="familyIncomeUnknownDeclined" kendoCheckBox />
                </label>
              </div>
              <div class="col-10" style="margin-top:-14px">
                <label class="k-form-field">
                  <kendo-numerictextbox [format]="'n0'" formControlName="familyIncome" [min]="0">
                  </kendo-numerictextbox>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="( ( ( (familyIncome.hasError('required')) && (familyIncome.value === null || familyIncome.value === '')) ||
                               ( (familyIncomeUnknownDeclined.hasError('required')) && (familyIncomeUnknownDeclined.value !== true && familyIncomeUnknownDeclined.value !== false))
                             ) 
                             &&
                             (familyIncome.touched || (memberForm.dirty && !isNew)))">
                    <span translate [translateParams]="{field: requiredText('FAMILY_INCOME')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-10">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('POVERTY_LEVEL'), 'k-text-uppercase-bold': isRecommended('POVERTY_LEVEL')}">
                    {{'POVERTY-LEVEL' | translate}}
                  </span>
                  <kendo-numerictextbox [format]="'n0'" formControlName="povertyLevel" [min]="0"
                    [spinners]="!povertyAPIEnabled">
                  </kendo-numerictextbox>
                  <a *ngIf="povertyAPIEnabled && !isReadOnly" title="{{'CHECK-POVERTY-LEVEL' | translate }}"
                    class="pointer mt-2" style="position:absolute;" (click)="checkPovertyLevel();">
                    <i class="fas fa-search-dollar fa-lg pl-2 icon-success"></i>
                  </a>
                </label>
                <small *ngIf="povertyLastModifiedOn && povertyLastModifiedOn.value" class="form-text text-muted"
                  style="margin-top:-8px">
                  {{'LAST-MODIFIED-DATE' | translate}} {{povertyLastModifiedOn.value | date: 'MMM d, y h:mm a'}}
                </small>
              </div>
              <div class="col-12">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('LIVES_ALONE'), 'k-text-uppercase-bold': isRecommended('LIVES_ALONE')}">
                    {{'LIVES-ALONE' | translate}} {{requiredLabel('LIVES_ALONE')}}
                  </span>
                  <input type="checkbox" [indeterminate]="livesAlone.value === null" formControlName="livesAlone"
                    kendoCheckBox />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="livesAlone.hasError('required') && (livesAlone.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('LIVES_ALONE')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('PRIMARY_CAREGIVER'), 'k-text-uppercase-bold': isRecommended('PRIMARY_CAREGIVER')}">
                    {{'PRIMARY-CAREGIVER' | translate}} {{requiredLabel('PRIMARY_CAREGIVER')}}
                  </span>
                  <input type="checkbox" [indeterminate]="primaryCaregiver.value === null"
                    formControlName="primaryCaregiver" kendoCheckBox />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="primaryCaregiver.hasError('required') && (primaryCaregiver.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('PRIMARY_CAREGIVER')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab *ngIf="insurancesEnabled" [selected]="false">
        <ng-template kendoTabTitle> {{ 'INSURANCES' | translate }} {{requiredLabel('MEDICAL_INSURANCE')}}
          <span *ngIf="tabCounts?.insurances > 0" class="badge badge-pill badge-counts">{{tabCounts?.insurances}}</span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="p-1">
            <button *ngIf="!isReadOnlyInsurances" kendoButton [primary]="true" (click)="addInsurance()" type="button">
              {{'NEW-INSURANCE' | translate}}<i class="far fa-plus"></i>
            </button>
            <div *ngIf="memberForm.controls.insurances.controls.length === 0" class="row mb-4 mt-2"
              style="color: rgba(0, 0, 0, 0.25);">
              <div class="col-12">
                <span>{{'NO-INSURANCES' | translate}}</span>
              </div>
            </div>
            <div formArrayName="insurances" class="container-opening-times">
              <div *ngFor="let insurance of memberForm.controls.insurances.controls; let i = index" [formGroupName]="i">
                <div class="k-form" [ngClass]="{'d-none': insurancesCollapsed && i >= 1}"
                  *ngIf="!memberForm.controls.insurances.controls[i].controls.deleted.value">
                  <div class="row">
                    <div class="col-6">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'INSURER' | translate}} {{requiredLabelInsurance('INSURER')}}
                        </span>
                        <kendo-dropdownlist #insurerDropdown id="insurer" class="w-100" [data]="insurersFiltered"
                          [filterable]="true" [textField]="'name'" [valueField]="'id'"
                          (filterChange)="handleInsurerFilter($event)" [itemDisabled]="insurerItemDisabled"
                          [defaultItem]="currentDefaultInsuredItem" (close)="searchTerm=''" formControlName="insurer"
                          [readonly]="isReadOnlyInsurances">
                          <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <span
                              innerHTML="{{ dataItem.name | highlight : searchTerm : currentDefaultInsuredItem.name }}">
                            </span>
                          </ng-template>
                        </kendo-dropdownlist>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.insurer.hasError('required') && memberForm.controls.insurances.controls[i].controls.insurer.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURER')}">{{ 'IS-REQUIRED'
                            }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'START-DATE' | translate}} {{requiredLabelInsurance('START_DATE')}}
                        </span>
                        <kendo-datepicker #startDateControl class="w-100" formControlName="startDate"
                          [readonly]="isReadOnlyInsurances">
                        </kendo-datepicker>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.startDate.hasError('required') && memberForm.controls.insurances.controls[i].controls.startDate.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('START_DATE')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'END-DATE' | translate}} {{requiredLabelInsurance('END_DATE')}}
                        </span>
                        <kendo-datepicker class="w-100" formControlName="endDate"
                          [readonly]="isReadOnlyInsurances"></kendo-datepicker>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.endDate.hasError('required') && memberForm.controls.insurances.controls[i].controls.endDate.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('END_DATE')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="row" style="margin-top: -15px;">
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'INSURED-FIRST-NAME' | translate}} {{requiredLabelInsurance('INSURED_FIRST_NAME')}}
                        </span>
                        <input id="insuredGivenName" kendoTextBox formControlName="insuredGivenName"
                          [readonly]="isReadOnlyInsurances" maxlength="150" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.insuredGivenName.hasError('required') && memberForm.controls.insurances.controls[i].controls.insuredGivenName.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURED_FIRST_NAME')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'INSURED-LAST-NAME' | translate}} {{requiredLabelInsurance('INSURED_LAST_NAME')}}
                        </span>
                        <input id="insuredFamilyName" kendoTextBox formControlName="insuredFamilyName"
                          [readonly]="isReadOnlyInsurances" maxlength="150" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.insuredFamilyName.hasError('required') && memberForm.controls.insurances.controls[i].controls.insuredFamilyName.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURED_LAST_NAME')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          <i class="fas fa-phone fa-fw"></i> {{'INSURER-BUSINESS-PHONE' | translate}}
                          {{requiredLabelInsurance('INSURER_PHONE')}}
                        </span>
                        <kendo-maskedtextbox [mask]="phoneNumberMask" id="businessPhoneNumber"
                          formControlName="businessPhoneNumber" [readonly]="isReadOnlyInsurances">
                        </kendo-maskedtextbox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.businessPhoneNumber.hasError('required') && memberForm.controls.insurances.controls[i].controls.businessPhoneNumber.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURER_PHONE')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          <i (click)="openInsurerUrl(i)" [ngClass]="{'has-valid-url': isValidInsurerUrl(i)}"
                            class="fas fa-link fa-fw"></i>
                          {{'INSURER-WWW-URL' | translate}} {{requiredLabelInsurance('INSURER_WEBSITE')}}
                        </span>
                        <input id="insurerUrl" kendoTextBox formControlName="insurerUrl"
                          [readonly]="isReadOnlyInsurances" maxlength="512" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="!isValidInsurerUrl(i) && memberForm.controls.insurances.controls[i].controls.insurerUrl.hasError('pattern') && memberForm.controls.insurances.controls[i].controls.insurerUrl.touched">
                          {{'INVALID-WWW' | translate}}
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.insurerUrl.hasError('required') && memberForm.controls.insurances.controls[i].controls.insurerUrl.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURER_WEBSITE')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="row" style="margin-top: -15px;">
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'INSURANCE-MEMBER-ID' | translate}} {{requiredLabelInsurance('INSURANCE_MEMBER_ID')}}
                        </span>
                        <input id="insuranceMemberId" kendoTextBox formControlName="insuranceMemberId"
                          [readonly]="isReadOnlyInsurances" maxlength="128" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.insuranceMemberId.hasError('required') && memberForm.controls.insurances.controls[i].controls.insuranceMemberId.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURANCE_MEMBER_ID')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'PLAN' | translate}} {{requiredLabelInsurance('PLAN')}}
                        </span>
                        <input id="plan" #planControl kendoTextBox formControlName="plan"
                          [readonly]="isReadOnlyInsurances" maxlength="255" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.plan.hasError('required') && memberForm.controls.insurances.controls[i].controls.plan.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('PLAN')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'GROUP-ID' | translate}} {{requiredLabelInsurance('GROUP_ID')}}
                        </span>
                        <input id="groupId" kendoTextBox formControlName="groupId" [readonly]="isReadOnlyInsurances"
                          maxlength="128" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.groupId.hasError('required') && memberForm.controls.insurances.controls[i].controls.groupId.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('GROUP_ID')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'INSURANCE-EXTERNAL-ID' | translate}} {{requiredLabelInsurance('INSURANCE_EXTERNAL_ID')}}
                        </span>
                        <input id="insuranceExternalId" kendoTextBox formControlName="insuranceExternalId"
                          [readonly]="isReadOnlyInsurances" maxlength="128" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.insuranceExternalId.hasError('required') && memberForm.controls.insurances.controls[i].controls.insuranceExternalId.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURANCE_EXTERNAL_ID')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="row" style="margin-top: -15px;">
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'POLICY-HOLDER' | translate}} {{requiredLabelInsurance('POLICY_HOLDER')}}
                        </span>
                        <input id="policyHolder" kendoTextBox formControlName="policyHolder"
                          [readonly]="isReadOnlyInsurances" maxlength="128" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.policyHolder.hasError('required') && memberForm.controls.insurances.controls[i].controls.policyHolder.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('POLICY_HOLDER')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'EMPLOYER' | translate}} {{requiredLabelInsurance('EMPLOYER')}}
                        </span>
                        <input id="employer" kendoTextBox formControlName="employer" [readonly]="isReadOnlyInsurances"
                          maxlength="255" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.insurances.controls[i].controls.employer.hasError('required') && memberForm.controls.insurances.controls[i].controls.employer.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('EMPLOYER')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <!--Insurance Card File-->
                    <div class="col-3">
                      <label class="k-form-field">
                        <span class="k-text-uppercase dark">
                          {{'INSURANCE-CARD' | translate}} {{requiredLabelInsurance('INSURANCE_CARD')}}
                        </span>
                        <span class="k-text-uppercase dark float-right" *ngIf="memberForm.controls.insurances.controls[i].controls !== undefined && 
                          memberForm.controls.insurances.controls[i].controls.cardDocumentName !== undefined &&
                          memberForm.controls.insurances.controls[i].controls.cardDocumentName.value !== null &&
                          !isNewFileSelected[i]">
                          <i class="fas fa-address-card fa-lg pointer" title="{{ 'VIEW-INSURANCE-CARD' | translate }}"
                            (click)="viewHandler(i)">
                          </i>
                        </span>
                        <input id="cardDocumentName" kendoTextBox formControlName="cardDocumentName"
                          [readonly]="true" />
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="memberForm.controls.insurances.controls[i].controls !== undefined && 
                          memberForm.controls.insurances.controls[i].controls.cardDocumentName !== undefined && 
                          memberForm.controls.insurances.controls[i].controls.cardDocumentName.hasError('required') && 
                          memberForm.controls.insurances.controls[i].controls.cardDocumentName.touched">
                          <span translate [translateParams]="{field: requiredTextInsurance('INSURANCE_CARD')}">{{
                            'IS-REQUIRED' }}</span>
                        </div>
                      </label>
                    </div>
                    <div class="col-3" style="margin-top:34px;">
                      <input class="d-none" type="file" (change)="onFileChanged($event,i)" #fileInput />
                      <button *ngIf="!isReadOnlyInsurances" kendoButton type="button" (click)="fileInput.click()">
                        {{'SELECT-INSURANCE-CARD' | translate}}<i class="far fa-id-card"></i>
                      </button><i *ngIf="(!isReadOnlyInsurances && (isNewFileSelected[i] || 
                      (memberForm.controls.insurances.controls[i].controls !== undefined && 
                       memberForm.controls.insurances.controls[i].controls.cardDocumentName !== undefined &&
                       memberForm.controls.insurances.controls[i].controls.cardDocumentName.value !== null)))"
                        class="fas fa-trash-alt fa-lg ml-2" title="{{'DELETE-INSURANCE-CARD' | translate}}"
                        (click)="deleteInsuranceCard(i)">
                      </i>
                      <span *ngIf="!isReadOnlyInsurances" style="position: absolute;right: 15px;top:2px;">
                        <a title="{{ 'DELETE' | translate }}"
                          (click)="removeInsurance(i,memberForm.controls.insurances.controls[i].controls.id.value)">
                          <i class="fas fa-fw fa-times-circle fa-delete-custom" style="padding-top:10px;"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                  <!--Other insurances-->
                  <div class="mt-2" *ngIf="i === 0 && memberForm.controls.insurances.controls.length > 1">
                    <span class="text-uppercase collapsible-text" (click)="insurancesCollapsible.toggleChange()">
                      {{'OTHER-INSURANCES' |
                      translate}}<span>&nbsp;({{memberForm.controls.insurances.controls.length-1}})</span>
                      <app-collapsible #insurancesCollapsible [storageKey]="'patient-insurances'"
                        (collapsibleToggle)="insurancesCollapsed=$event" [defaultCollapsed]="true">
                      </app-collapsible>
                    </span>
                  </div>
                  <hr *ngIf="memberForm.controls.insurances.controls.length > 1 &&
                                i < memberForm.controls.insurances.controls.length-1"
                    [ngClass]="{'mt-0': i === 0 && memberForm.controls.insurances.controls.length > 1}">
                </div>
              </div>
            </div>
          </div>
          <div>* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'DEMOGRAPHICS' | translate}}" [selected]="false">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <div class="col-4" *ngIf="allRaceEthnicities.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('RACE_ETHNICITIES'), 'k-text-uppercase-bold': isRecommended('RACE_ETHNICITIES')}">
                    {{'RACE-ETHNICITIES' | translate}} {{requiredLabel('RACE_ETHNICITIES')}}
                  </span>
                  <kendo-multiselect id="raceEthnicities" [data]="raceEthnicitiesFiltered"
                    attr.aria-label="{{'RACE-ETHNICITIES' | translate}}" formControlName="raceEthnicities"
                    [textField]="'displayName'" [filterable]="true" role="combobox" [valueField]="'id'"
                    (filterChange)="filterRaceEthnicities($event)" (close)="searchTerm=''" [autoClose]="true"
                    [virtual]="virtualRaceEthnicity" aria-expanded="false" aria-controls=".k-list-ul">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="raceEthnicities.hasError('required') && (raceEthnicities.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('RACE_ETHNICITIES')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="allRaces.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('RACES'), 'k-text-uppercase-bold': isRecommended('RACES')}">
                    {{'RACES' | translate}} {{requiredLabel('RACES')}}
                  </span>
                  <kendo-multiselect id="races" [data]="racesFiltered" formControlName="races"
                    attr.aria-label="{{'RACES' | translate}}" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterRaces($event)" (close)="searchTerm=''" [autoClose]="true"
                    [virtual]="virtualRace">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="races.hasError('required') && (races.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('RACES')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="maritalStatuses.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('MARITAL_STATUS'), 'k-text-uppercase-bold': isRecommended('MARITAL_STATUS')}">
                    {{'MARITAL-STATUS' | translate}} {{requiredLabel('MARITAL_STATUS')}}
                  </span>
                  <kendo-combobox id="maritalStatus" formControlName="maritalStatus" [data]="maritalStatuses"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="maritalStatus.hasError('required') && (maritalStatus.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('MARITAL_STATUS')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-4" *ngIf="veteranStatuses.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('VETERAN_STATUS'), 'k-text-uppercase-bold': isRecommended('VETERAN_STATUS')}">
                    {{'VETERAN-STATUS' | translate}} {{requiredLabel('VETERAN_STATUS')}}
                  </span>
                  <kendo-combobox id="veteranStatus" class="w-100" formControlName="veteranStatus"
                    [data]="veteranStatuses" [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="veteranStatus.hasError('required') && (veteranStatus.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('VETERAN_STATUS')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="religiousAffiliations.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('RELIGIOUS_AFFILIATION'), 'k-text-uppercase-bold': isRecommended('RELIGIOUS_AFFILIATION')}">
                    {{'RELIGIOUS-AFFILIATION' | translate}} {{requiredLabel('RELIGIOUS_AFFILIATION')}}
                  </span>
                  <kendo-combobox id="religiousAffiliation" formControlName="religiousAffiliation"
                    [data]="religiousAffiliations" [textField]="'displayName'" [valueField]="'code'"
                    [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="religiousAffiliation.hasError('required') && (religiousAffiliation.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('RELIGIOUS_AFFILIATION')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="sexualOrientations.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('SEXUAL_ORIENTATION'), 'k-text-uppercase-bold': isRecommended('SEXUAL_ORIENTATION')}">
                    {{'SEXUAL-ORIENTATION' | translate}} {{requiredLabel('SEXUAL_ORIENTATION')}}
                  </span>
                  <kendo-combobox id="sexualOrientation" formControlName="sexualOrientation" [data]="sexualOrientations"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="sexualOrientation.hasError('required') && (sexualOrientation.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('SEXUAL_ORIENTATION')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="employmentStatuses.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('EMPLOYMENT_STATUS'), 'k-text-uppercase-bold': isRecommended('EMPLOYMENT_STATUS')}">
                    {{'EMPLOYMENT-STATUS' | translate}} {{requiredLabel('EMPLOYMENT_STATUS')}}
                  </span>
                  <kendo-combobox id="employmentStatus" formControlName="employmentStatus" [data]="employmentStatuses"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="employmentStatus.hasError('required') && (employmentStatus.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('EMPLOYMENT_STATUS')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="housingStatuses.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('HOUSING'), 'k-text-uppercase-bold': isRecommended('HOUSING')}">
                    {{'HOUSING-STATUS' | translate}} {{requiredLabel('HOUSING')}}
                  </span>
                  <kendo-combobox id="housingStatus" class="w-100" formControlName="housingStatus"
                    [data]="housingStatuses" [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="housingStatus.hasError('required') && (housingStatus.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('HOUSING')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-4" *ngIf="educationLevels.length > 0">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('EDUCATION_LEVEL'), 'k-text-uppercase-bold': isRecommended('EDUCATION_LEVEL')}">
                    {{'EDUCATION-LEVEL' | translate}} {{requiredLabel('EDUCATION_LEVEL')}}
                  </span>
                  <kendo-combobox id="educationLevel" formControlName="educationLevel" [data]="educationLevels"
                    [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="educationLevel.hasError('required') && (educationLevel.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('EDUCATION_LEVEL')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div>* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{'CONSENTS' | translate }}" [selected]="openPatientConsentTab">
        <ng-template kendoTabContent>
          <app-patient-edit-consent [isReadOnly]="isReadOnly" [pendingConsents]="pendingConsents"
            [deletedConsents]="deletedConsents" [member]="member" [patientName]="getPatientFullName()"
            (delete)="consentDeleted($event)" (add)="consentAdded($event)">
          </app-patient-edit-consent>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'IDENTIFIERS' | translate }}">
        <ng-template kendoTabContent>
          <div class="tab-identifiers">
            <div class="p-1">
              <button *ngIf="!isReadOnly" kendoButton [primary]="true" (click)="addIdentifier()" type="button"
                class="mb-2">
                {{'ADD-IDENTIFIER' | translate}}<i class="far fa-plus"></i>
              </button>
              <div formArrayName="identifiers" class="container-opening-times">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'TYPE' | translate }} *</label>
                      </th>
                      <th>
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'VALUE' | translate }} * </label>
                      </th>
                      <th>
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'SOURCE' | translate }} </label>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let option of memberForm.controls.identifiers.controls; let i=index"
                      [formGroupName]="i">
                      <td style="width:30%">
                        <kendo-combobox formControlName="type" [data]="types" [textField]="'displayName'"
                          [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.identifiers.controls[i].controls.type.hasError('required') && 
                                                                     memberForm.controls.identifiers.controls[i].controls.type.touched">
                          {{ 'REQUIRED-TYPE' | translate }}
                        </div>
                      </td>
                      <td style="width:30%">
                        <input id="value" kendoTextBox formControlName="value" class="w-100" maxlength="1024" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.identifiers.controls[i].controls.value.hasError('required') &&
                                                                     memberForm.controls.identifiers.controls[i].controls.value.touched">
                          {{ 'REQUIRED-VALUE' | translate }}
                        </div>
                      </td>
                      <td style="width:35%">
                        <kendo-combobox formControlName="source" [data]="sources" [textField]="'displayName'"
                          [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                      </td>
                      <td>
                        <a *ngIf="!isReadOnly" title="{{ 'DELETE' | translate }}"
                          (click)="removeIdentifier(i,memberForm.controls.identifiers.controls[i].controls.id.value)">
                          <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                      </td>
                    </tr>
                    <!--Channels MRN-->
                    <tr *ngIf="member?.mrn">
                      <td style="width:30%">
                        <input kendoTextBox [disabled]="true" [(ngModel)]="channelsTypeText"
                          [ngModelOptions]="{standalone: true}" />
                      </td>
                      <td style="width:30%">
                        <input kendoTextBox [disabled]="true" [(ngModel)]="member.mrn"
                          [ngModelOptions]="{standalone: true}" />
                      </td>
                      <td style="width:35%">
                        <input kendoTextBox [disabled]="true" [(ngModel)]="channelsSourceText"
                          [ngModelOptions]="{standalone: true}" />
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>* {{'REQUIRED-FIELDS' | translate}}</div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'TRIBAL-INFO' | translate}}" *ngIf="allowTribalPerUserOrganization &&
      (allTribalAffiliations.length > 0 || allTribalEnrollments.length > 0)" [selected]="false">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row" *ngIf="allTribalAffiliations.length > 0">
              <div class="col-3">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('TRIBAL_AFFILIATED'), 'k-text-uppercase-bold': isRecommended('TRIBAL_AFFILIATED')}">
                    {{'TRIBAL-AFFILIATED' | translate}} {{requiredLabel('TRIBAL_AFFILIATED')}}
                  </span>
                  <input type="checkbox" [indeterminate]="tribalAffiliated.value === null"
                    formControlName="tribalAffiliated" kendoCheckBox />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="tribalAffiliated.hasError('required') && (tribalAffiliated.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('TRIBAL_AFFILIATED')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-9" *ngIf="tribalAffiliated && tribalAffiliated.value && showTribalAffiliations">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('TRIBAL_AFFILIATIONS'), 'k-text-uppercase-bold': isRecommended('TRIBAL_AFFILIATIONS')}">
                    {{'TRIBAL-AFFILIATIONS' | translate}} {{requiredLabel('TRIBAL_AFFILIATIONS')}}
                  </span>
                  <kendo-multiselect id="tribalAffiliations" [data]="tribalAffiliationsFiltered"
                    formControlName="tribalAffiliations" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterTribalAffiliations($event)" (close)="searchTerm=''"
                    [autoClose]="true" [virtual]="virtualTribalAffiliation" role="combobox"
                    attr.aria-label="{{'TRIBAL-AFFILIATIONS' | translate}}" aria-expanded="false"
                    aria-controls=".k-list-ul">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="tribalAffiliations.hasError('required') && (tribalAffiliations.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('TRIBAL_AFFILIATIONS')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row mb-2" *ngIf="allTribalEnrollments.length > 0">
              <div class="col-3">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('TRIBAL_ENROLLED'), 'k-text-uppercase-bold': isRecommended('TRIBAL_ENROLLED')}">
                    {{'TRIBAL-ENROLLED' | translate}} {{requiredLabel('TRIBAL_ENROLLED')}}
                  </span>
                  <input type="checkbox" [indeterminate]="tribalEnrolled.value === null"
                    formControlName="tribalEnrolled" kendoCheckBox />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="tribalEnrolled.hasError('required') && (tribalEnrolled.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('TRIBAL_ENROLLED')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
              <div class="col-9" *ngIf="tribalEnrolled && tribalEnrolled.value && showTribalEnrollments">
                <label class="k-form-field">
                  <span
                    [ngClass]="{'k-text-uppercase dark': !isRecommended('TRIBAL_ENROLLMENTS'), 'k-text-uppercase-bold': isRecommended('TRIBAL_ENROLLMENTS')}">
                    {{'TRIBAL-ENROLLMENTS' | translate}} {{requiredLabel('TRIBAL_ENROLLMENTS')}}
                  </span>
                  <kendo-multiselect id="tribalEnrollments" [data]="tribalEnrollmentsFiltered"
                    formControlName="tribalEnrollments" [textField]="'displayName'" [filterable]="true"
                    [valueField]="'id'" (filterChange)="filterTribalEnrollments($event)" (close)="searchTerm=''"
                    [autoClose]="true" [virtual]="virtualTribalEnrollment" role="combobox"
                    attr.aria-label="{{'TRIBAL-ENROLLMENTS' | translate}}" aria-expanded="false"
                    aria-controls=".k-list-ul">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="tribalEnrollments.hasError('required') && (tribalEnrollments.touched || (memberForm.dirty && !isNew))">
                    <span translate [translateParams]="{field: requiredText('TRIBAL_ENROLLMENTS')}">{{ 'IS-REQUIRED'
                      }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div>* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'EXTENSIONS' | translate }}"
        *ngIf="viewExtensions?.gridData?.total > 0 || patientExtensionsEditable">
        <ng-template kendoTabContent>
          <kendo-grid [data]="viewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
            [navigable]="true" [sort]="viewExtensions.state.sort" [resizable]="true" style="max-height: 400px;"
            class="mt-2 mb-2" (dataStateChange)="patExtensionsDataStateChange($event)" [kendoGridSelectBy]="'id'"
            (add)="patExtensionAddHandler($event)" (save)="patExtensionSaveHandler($event)"
            (edit)="patExtensionEditHandler($event)" (cancel)="patExtensionCancelHandler($event)">
            <kendo-grid-messages noRecords="{{ 'NO-EXTENSIONS' | translate }}"></kendo-grid-messages>
            <!--Organization Name -->
            <kendo-grid-column field="settingExtension.organization.name"
              title="{{ 'SOURCE-ORGANIZATION' | translate }}" [width]="50" [filterable]="false" [sortable]="true">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span
                  *ngIf="dataItem.settingExtension.organization">{{dataItem.settingExtension.organization.name}}</span>
              </ng-template>
              <ng-template kendoGridEditTemplate>
                <div [formGroup]="patExtensionFormGroup">
                  <kendo-combobox id="organization" formControlName="organization" [data]="organizations"
                    [textField]="'name'" [valueField]="'id'" (valueChange)="organizationChange(true)"
                    [readonly]="!isOperatorRole">
                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                      <span
                        [ngClass]="{'font-weight-bold': isOrganizationHasExtension(dataItem.id)}">{{dataItem.name}}</span>
                    </ng-template>
                  </kendo-combobox>
                </div>
              </ng-template>
            </kendo-grid-column>
            <!--Extension Name-->
            <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}"
              [filterable]="false" [sortable]="true">
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="patExtensionFormGroup">
                <kendo-dropdownlist [data]="extensionsByCategoryAndOrganizationUnused" textField="name" valueField="id"
                  [valuePrimitive]="false" [formControl]="patExtensionFormGroup.get('settingExtension')">
                </kendo-dropdownlist>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                <span title="{{dataItem.displayLabel}}"
                  *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="value" [width]="40" title="{{ 'VALUE' | translate }}">
              <ng-template kendoGridEditTemplate>
                <div [formGroup]="patExtensionFormGroup">
                  <input kendoTextBox formControlName="value" maxlength="10485760" />
                </div>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.value">{{formatExtensionValue(dataItem)}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="viewExtensionsShowAlternateValue" field="alternateValue" [width]="40"
              title="{{ 'ALTERNATE-VALUE' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column *ngIf="viewExtensionsShowDisplayName" field="displayName" [width]="65"
              title="{{ 'DISPLAY-NAME' | translate }}">
            </kendo-grid-column>
            <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center"
              *ngIf="!isReadOnly && patientExtensionsEditable">
              <ng-template kendoGridCellTemplate let-dataItem>
                <ng-container *ngIf="dataItem.editing">
                  <ng-container *ngIf="patExtensionFormGroup !== null && patExtensionFormGroup.valid">
                    <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                      (click)="patExtensionSaveButton.click.emit($event); dataItem.editing = false">
                    </i>
                    &nbsp;
                  </ng-container>
                  <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                    (click)="patExtensionCancelButton.click.emit($event); dataItem.editing = false;"></i>
                  <button kendoGridSaveCommand #patExtensionSaveButton class="d-none"></button>
                  <button kendoGridCancelCommand #patExtensionCancelButton class="d-none"></button>
                </ng-container>
                <ng-container *ngIf="!dataItem.editing">
                  <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                    (click)="patExtensionEditButton.click.emit($event); dataItem.editing = true;"></i>
                  &nbsp;
                  <button kendoGridEditCommand #patExtensionEditButton class="d-none"></button>
                  <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                    (click)="deletePatExtension(dataItem)"></i>
                </ng-container>
              </ng-template>
            </kendo-grid-command-column>
            <button kendoGridAddCommand #patExtensionAddButton class="d-none"></button>
          </kendo-grid>
          <button *ngIf="!isReadOnly && patientExtensionsEditable" kendoButton [primary]="false" type="button"
            class="float-right mt-2 mb-3" (click)="patExtensionAddButton.click.emit($event);">{{'ADD' | translate}}<i
              class="far fa-plus"></i>
          </button>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'OTHER-CONTACTS' | translate }}" *ngIf="patientContactTeams && !isNew">
        <ng-template kendoTabContent>
          <div class="mt-2 mb-2">
            <kendo-grid [data]="viewOtherContacts.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
              [sort]="viewOtherContacts.state.sort" [resizable]="true" style="max-height: 400px;" [navigable]="true"
              (dataStateChange)="dataStateChangeViewOtherContacts($event)">
              <kendo-grid-column field="name" [width]="100" title="{{ 'NAME' | translate }}">
              </kendo-grid-column>
              <kendo-grid-column field="teamRole" [width]="80" title="{{ 'ROLE' | translate }}">
              </kendo-grid-column>
              <kendo-grid-column field="teamSubRole" [width]="80" title="{{ 'SUBROLE' | translate }}">
              </kendo-grid-column>
              <kendo-grid-column title="{{ 'CONTACT' | translate }}" [width]="100" [sortable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="row">
                    <div class="col-12" *ngIf="dataItem.homePhoneNumber"
                      title="{{'HOME-OR-PRACTICE-PHONE' | translate}}">
                      <i class="fas fa-phone fa-fw"></i>&nbsp;{{dataItem.homePhoneNumber | phone}}
                      <span *ngIf="dataItem.homePhoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                        translate}}&nbsp;{{dataItem.homePhoneNumberExtension}}</span>
                    </div>
                    <div class="col-12" *ngIf="dataItem.cellPhoneNumber" title="{{'CELL-PHONE' | translate}}">
                      <i class="fas fa-mobile-android-alt fa-fw"></i>&nbsp;{{dataItem.cellPhoneNumber |
                      phone}}
                    </div>
                    <div class="col-12" *ngIf="dataItem.workPhoneNumber" title="{{'WORK-PHONE' | translate}}">
                      <i class="fas fa-phone-office fa-fw"></i>&nbsp;{{dataItem.workPhoneNumber | phone}}
                      <span *ngIf="dataItem.workPhoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                        translate}}&nbsp;{{dataItem.workPhoneNumberExtension}}</span>
                    </div>
                    <div class="col-12" *ngIf="dataItem.otherPhoneNumber" title="{{'OTHER-PHONE' | translate}}">
                      <i class="fas fa-phone fa-fw"></i>&nbsp;{{dataItem.otherPhoneNumber |
                      phone}}
                    </div>
                    <div class="col-12" *ngIf="dataItem.email" title="{{'EMAIL' | translate}}">
                      <i class="fas fa-envelope fa-fw"></i>&nbsp;
                      <a href="mailto:{{dataItem.email}}" target="_blank">
                        {{dataItem.email}}
                      </a>
                    </div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-command-column *ngIf="!formDirty()" [width]="20" title="{{ 'ACTION' | translate }}"
                class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                    (click)="editOtherContactsHandler(dataItem)"></i>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'OTHER-NAMES' | translate }}">
        <ng-template kendoTabContent>
          <div class="tab-other-names">
            <div class="p-1">
              <button *ngIf="!isReadOnly" kendoButton [primary]="true" (click)="addOtherName()" type="button"
                class="mb-2">
                {{'ADD-OTHER-NAME' | translate}}<i class="far fa-plus"></i>
              </button>
              <div formArrayName="otherNames" class="container-opening-times">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'NAME-TYPE' | translate }} *</label>
                      </th>
                      <th>
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'FIRST-NAME' | translate }}
                          {{requiredLabel('FIRST_NAME_OTHER_NAMES')}} </label>
                      </th>
                      <th>
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'LAST-NAME' | translate }}
                          {{requiredLabel('LAST_NAME_OTHER_NAMES')}} </label>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let option of memberForm.controls.otherNames.controls; let i=index" [formGroupName]="i">
                      <td style="width:30%">
                        <kendo-combobox formControlName="nameType" [data]="nameTypes" [textField]="'displayName'"
                          [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.otherNames.controls[i].controls.nameType.hasError('required') && 
                                                                           memberForm.controls.otherNames.controls[i].controls.nameType.touched">
                          {{ 'REQUIRED-NAME-TYPE' | translate }}
                        </div>
                      </td>
                      <td style="width:30%">
                        <input id="givenName" kendoTextBox formControlName="givenName" class="w-100" maxlength="1024" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.otherNames.controls[i].controls.givenName.hasError('required') &&
                                                                           memberForm.controls.otherNames.controls[i].controls.givenName.touched">
                          {{ 'REQUIRED-FIRST-NAME' | translate }}
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="firstOrLastNameRequired && !memberForm.controls.otherNames.controls[i].controls.givenName.hasError('required') &&
                                 (memberForm.controls.otherNames.controls[i].controls.givenName.value === null || memberForm.controls.otherNames.controls[i].controls.givenName.value === '') && 
                                 (memberForm.controls.otherNames.controls[i].controls.familyName.value === null || memberForm.controls.otherNames.controls[i].controls.familyName.value === '') &&
                                 memberForm.controls.otherNames.controls[i].controls.givenName.touched">
                          {{ 'REQUIRED-FIRST-OR-LAST-NAME' | translate }}
                        </div>
                      </td>
                      <td style="width:30%">
                        <input id="familyName" kendoTextBox formControlName="familyName" class="w-100"
                          maxlength="1024" />
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="memberForm.controls.otherNames.controls[i].controls.familyName.hasError('required') &&
                                                                                                 memberForm.controls.otherNames.controls[i].controls.familyName.touched">
                          {{ 'REQUIRED-LAST-NAME' | translate }}
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="firstOrLastNameRequired && !memberForm.controls.otherNames.controls[i].controls.familyName.hasError('required') &&
                                 (memberForm.controls.otherNames.controls[i].controls.givenName.value === null || memberForm.controls.otherNames.controls[i].controls.givenName.value === '') && 
                                 (memberForm.controls.otherNames.controls[i].controls.familyName.value === null || memberForm.controls.otherNames.controls[i].controls.familyName.value === '') &&
                                 memberForm.controls.otherNames.controls[i].controls.familyName.touched">
                          {{ 'REQUIRED-FIRST-OR-LAST-NAME' | translate }}
                        </div>
                      </td>
                      <td>
                        <a *ngIf="!isReadOnly" title="{{ 'DELETE' | translate }}"
                          (click)="removeOtherName(i,memberForm.controls.otherNames.controls[i].controls.id.value)">
                          <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>* {{'REQUIRED-FIELDS' | translate}}</div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{'MEMBER-RESTRICTIONS' | translate}}" [selected]="false"
        *ngIf="patientRestrictionsEnabled">
        <ng-template kendoTabTitle> {{ 'MEMBER-RESTRICTIONS' | translate }}
          <span *ngIf="memberOrganizations?.value?.length > 0"
            class="badge badge-pill badge-counts">{{memberOrganizations?.value?.length}}</span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <div class="col-12">
                <label for="organizations" class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{ 'ORGANIZATIONS' | translate }} <span style="display: inline-flex">
                      <div kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(authorizedOrganizations)"
                        (mouseover)="showTooltip(authorizedOrganizations)" aria-live="polite" (blur)="hideTooltip()"
                        (mouseout)="hideTooltip()">
                        <a #authorizedOrganizations
                          title="{{'AUTHORIZED-ORGANIZATIONS-TOOLTIP' | translate:patientLabel }}"><i
                            class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </span>
                  <kendo-multiselect id="organizations" [data]="organizationsFiltered"
                    attr.aria-label="{{'ORGANIZATIONS' | translate}}" aria-expanded="false" aria-controls=".k-list-ul"
                    [textField]="'name'" [filterable]="true" [valueField]="'id'" formControlName="memberOrganizations"
                    (filterChange)="filterRestrictedOrganizations($event)" (close)="searchTerm=''" [autoClose]="true"
                    [virtual]="virtualOrganization" [itemDisabled]="itemDisabled">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
</div>

<!--Duplicate member confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="memberExistsDialogOpened"
  (close)="memberExistsDialogOpened = false;" [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-MEMBER-ADD' | translate:patientLabel }}</p>
  <span class="k-font-weight-bold">{{memberToSave.givenName}} {{memberToSave.familyName}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="continueSaveAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="continueSaveAction(true)" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-address-validator #addressValidator (changeAddress)="changeAddress($event)" (save)="savePatient()"
  (cancelling)="saving = false;">
</app-address-validator>

<!--Document viewer only-->
<app-document [viewerOnly]="true" #documentComponent></app-document>